import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 pt-[68px] text-center" data-testid="not-found">
      <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-ztk-blue/10 text-ztk-blue">
        <Compass className="h-8 w-8" />
      </div>
      <p className="label-mono text-ztk-blue">Błąd 404</p>
      <h1 className="mt-2 font-display text-4xl font-extrabold text-ztk-navy dark:text-white">Nie znaleziono strony</h1>
      <p className="mt-3 max-w-md text-muted-foreground">
        Strona, której szukasz, nie istnieje lub została przeniesiona.
      </p>
      <Button asChild className="mt-6 bg-ztk-blue hover:bg-ztk-navy800" data-testid="notfound-home">
        <Link to="/">Wróć na stronę główną</Link>
      </Button>
    </div>
  );
}
